import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import ptCommon from "@/i18n/pt-BR/common.json";
import enCommon from "@/i18n/en-US/common.json";
import ptAuth from "@/i18n/pt-BR/auth.json";
import enAuth from "@/i18n/en-US/auth.json";
import ptBackoffice from "@/i18n/pt-BR/backoffice.json";
import enBackoffice from "@/i18n/en-US/backoffice.json";

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "pt-BR",
    supportedLngs: ["pt-BR", "en-US"],
    ns: ["common", "auth", "backoffice"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    detection: {
      order: ["cookie", "htmlTag"],
      caches: ["cookie"],
      lookupCookie: "imobgo.locale",
      cookieMinutes: 60 * 24 * 365,
    },
    resources: {
      "pt-BR": {
        common: ptCommon,
        auth: ptAuth,
        backoffice: ptBackoffice,
      },
      "en-US": {
        common: enCommon,
        auth: enAuth,
        backoffice: enBackoffice,
      },
    },
    react: { useSuspense: false },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

document.documentElement.lang = i18n.resolvedLanguage ?? "pt-BR";

export default i18n;
